import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { customerPageData, customerFAQs } from "./customerdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForCustomerManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Customer Management Software — AI-Powered Customer Intelligence"
        description="EkkBaz AI gives you a 360° view of every customer — order history, payment status, churn risk, and upsell opportunities. Increase retention by 35% and grow repeat revenue by 45%."
        keywords="customer management software, CRM AI, customer retention software, customer analytics, B2B customer management, churn prevention AI"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/customer`}
        productName="Customer Management"
        faqItems={customerFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Customer Management"
        subtitle="A 360° AI-powered view of every customer. Predict churn, personalise engagement, and grow repeat revenue by 45%."
        from="customer"
      />
      <EnhancedPageLayout {...customerPageData} />
      <UpdateFooter />
    </div>
  );
}
